const IMAGE_URL_KEYS = [
  'signed_url',
  'url',
  'path',
  's3_route',
  'src',
  'image_url',
  'thumbnail'
];

function extractImageUrl(imageObj: any): string | null {
  for (const key of IMAGE_URL_KEYS) {
    if (imageObj[key] && typeof imageObj[key] === 'string') {
      return imageObj[key];
    }
  }
  return null;
}

export async function convertImagesToBase64(images: (File | string | any)[]): Promise<string[]> {
  const base64List: string[] = [];

  for (const img of images) {
    // Caso 1: string directo (base64 o URL)
    if (typeof img === 'string') {
      base64List.push(img);
    }

    // Caso 2: Blob o File
    else if (img instanceof Blob) {
      const base64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(img);
      });
      base64List.push(base64);
    }

    // Caso 3: objeto con alguna key válida de imagen
    else if (typeof img === 'object') {
      const url = extractImageUrl(img);
      if (url) {
        base64List.push(url);
      } else {
        console.warn('Imagen no válida, ignorada:', img);
      }
    }

    // Cualquier otro tipo inválido
    else {
      console.warn('Tipo desconocido de imagen, ignorado:', img);
    }
  }

  return base64List;
}